export default __webpack_public_path__ + "static/media/Arrow-left.e5d44406.svg";